import * as React from 'react'

import { Box, Text } from '@factorialco/deprecated-design-system'
import type { Field, Form } from 'factorial-form'
import xor from 'lodash/xor'

import { observer } from 'mobx-react'

import LabeledFancyCheckbox from 'modules/core/components/Inputs/LabeledFancyCheckbox'
import i18n from 'modules/core/lib/i18n'

interface Props {
  form: Form
  categories: Record<string, string>
  selectedCategories: string[]
  setSelectedCategories: (arg0: string[]) => void
}

const Categories = ({ form, categories, selectedCategories, setSelectedCategories }: Props) => {
  const categoriesKeys = Object.keys(categories)

  const onChange = (category: string, field: Field) => {
    field.set(!field.value)
    setSelectedCategories(xor(selectedCategories, [category]))
  }

  return (
    <>
      <Text.Header3>{i18n.t('custom_reports.reports_library.categories.title')}</Text.Header3>
      <Box component="ul" gap="s8" paddingTop="s8">
        {categoriesKeys.map((category) => (
          <LabeledFancyCheckbox
            key={category}
            readOnly={false}
            field={form.get(category)}
            label={categories[category] ?? ''}
            onChange={() => onChange(category, form.get(category))}
          />
        ))}
      </Box>
    </>
  )
}

export default observer(Categories)
